module.exports = __webpack_public_path__ + "static/media/logo.0fe0d094.png";